<template>
  <div
    id="ClockOut_main"
    v-loading.fullscreen.lock="clockOutFullscreenLoading"
  >
    <!-- 未下班打卡記錄 -->
    <el-dialog
      title="請選擇您的打卡記錄"
      :visible.sync="dialogVisible"
      custom-class="clockOutDialog"
      :close-on-click-modal="false"
      width="70%"
    >
      <div
        v-if="webcamUrl"
        class="showWebCam"
        :style="`background-image: url(${webcamUrl})`"
      />
      <div
        v-else
        class="showWebCam non-webcam"
      />
      <el-table
        :data="tableData"
        style="width: 100%"
        class="clockOutTable"
      >
        <el-table-column
          type="index"
          align="left"
          width="50"
        />
        <el-table-column
          prop="ManagerName"
          label="姓名"
        />
        <el-table-column
          prop="ManagerJob"
          label="職務"
        />
        <el-table-column
          prop="ManagerShifts"
          label="班別"
        />
        <el-table-column label="上班時間">
          <template slot-scope="scope">
            <span>{{ scope.row.ClockTime.substring(0,16) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          min-width="50"
        >
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="primary"
              plain
              @click="clockOut(scope.row.ManagerName, scope.row.ClockId)"
            >
              下班
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-button
        class="cancelBtn"
        round
        @click="dialogVisible = false"
      >
        取消
      </el-button>
    </el-dialog>
    <!-- / 未下班打卡記錄 -->
    <!-- 手機號碼輸入彈窗 -->
    <el-dialog
      :visible.sync="phoneDialogVisible"
      custom-class="phoneDialog"
      width="400px"
      top="35vh"
      center
      @opened="$refs.phone.focus()"
      @close="closePhoneDialog"
    >
      <el-form
        ref="phoneDialogForm"
        :model="formData"
        :rules="rules"
        label-position="top"
        class="form"
        @submit.native.prevent="submitPhone()"
      >
        <el-form-item
          label="請輸入您的手機"
          prop="phone"
        >
          <el-input
            ref="phone"
            v-model="formData.phone"
            placeholder="請輸入手機號碼"
            maxlength="10"
          />
        </el-form-item>
      </el-form>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          round
          @click="closePhoneDialog"
        >
          取消
        </el-button>
        <el-button
          type="primary"
          round
          @click="submitPhone"
        >
          確定
        </el-button>
      </div>
    </el-dialog>
    <!-- / 手機號碼輸入彈窗 -->
    <ReadClockCard
      ref="readClockCard"
      @sandClockCard="sandClockCard"
      @disposable="phoneDialogVisible = true"
    />
    <ClockResultDialog ref="ClockResultDialog" />
  </div>
</template>
<script>
import ReadClockCard from './ReadClockCard'
import ClockResultDialog from './ClockResultDialog'
export default {
  components: {
    ReadClockCard,
    ClockResultDialog
  },
  data () {
    const formDataRule = (rule, value, callback) => {
      const reg = /^09[0-9]{8}$/
      // eslint-disable-next-line eqeqeq
      if (value == '' || value == undefined) {
        return callback(new Error('手機不可為空'))
      } else if (!reg.test(value)) {
        return callback(new Error('手機格式錯誤，請輸入正確手機號碼'))
      } else {
        return callback()
      }
    }
    return {
      dialogVisible: false,
      phoneDialogVisible: false,
      tableData: [],
      webcamUrl: '',
      requestData: new FormData(),
      formData: {
        phone: ''
      },
      rules: {
        phone: [
          { validator: formDataRule, trigger: 'blur' }
        ]
      },
      clockId: '',
      managerName: '',
      clockOutFullscreenLoading: false
    }
  },
  mounted () {
  },
  methods: {
    startClockOut (data) {
      console.log(data)
      this.webcamUrl = data.webcamUrl
      // 取得列表資料
      apiAttendanceManagement.ClockOut.GetNoClockOutList().then(res => {
        // 處理列表資料
        if (res.data.Status === 1) {
          if (res.data.Data.length === 0) {
            this.dialogVisible = false
            this.$confirm('目前沒有可下班的打卡記錄，無法完成打卡', '警告', {
              confirmButtonText: '確定',
              showCancelButton: false,
              closeOnClickModal: false,
              type: 'warning'
            }).then(() => {
              this.$emit('backStep1')
            }).catch(() => {
              this.$emit('backStep1')
            })
          } else if (res.data.Data.length === 1) {
            this.dialogVisible = false
            this.$refs.readClockCard.openDialog()
            this.clockId = res.data.Data[0].ClockId
          } else {
            this.dialogVisible = true
            this.tableData = res.data.Data
          }
        }
      }).catch(err => {
        console.log('錯誤訊息：', err.response)
      })
      this.requestData = new FormData()
      this.requestData.set('Longitude', 0)
      this.requestData.set('Latitude', 0)
      this.requestData.set('ClockImgFile', data.webcamFile)
      this.requestData.set('IsWarning', data.isWarning)
    },
    clockOut (managerName, clockId) {
      this.dialogVisible = false
      this.managerName = managerName
      this.clockId = clockId
      this.$refs.readClockCard.openDialog()
    },
    // 掃描結束回傳感應卡code
    sandClockCard (code) {
      this.clockOutFullscreenLoading = true
      this.requestData.set('ClockCard', code)
      // 進行有載具下班流程
      apiAttendanceManagement.ClockOut.PostClockOut(
        {
          ClockId: this.clockId
        },
        this.requestData
      ).then(res => {
        // eslint-disable-next-line eqeqeq
        if (res.data.Status == 1) {
          this.$message({
            message: res.data.Data.Name + '打卡成功，刷卡時間為：' + res.data.Data.ClockTime,
            type: 'success'
          })
          this.$router.push({ name: 'AttendanceManagement' })
        }
        this.clockOutFullscreenLoading = false
      }).catch(err => {
        if (err.response.status === 400 || err.response.status === 404) {
          this.$confirm(err.response.data.ErrorMessage.Description, '錯誤', {
            confirmButtonText: '確定',
            showCancelButton: false,
            closeOnClickModal: false,
            type: 'error'
          }).then(() => {
            this.$emit('backStep1')
          }).catch(() => {
            this.$emit('backStep1')
          })
        }
        this.clockOutFullscreenLoading = false
        console.log('錯誤訊息：', err.response)
      })
    },
    // 一次性打卡下班流程
    submitPhone () {
      console.log('submitPhone')
      this.$refs.phoneDialogForm.validate((valid) => {
        console.log(valid)
        if (!valid) {
          return false
        } else {
          console.log(this.requestData)
          this.requestData.set('Phone', this.formData.phone)
          apiAttendanceManagement.ClockOut.PostOneTimeClockOut(
            {
              ClockId: this.clockId
            },
            this.requestData
          ).then(res => {
            // eslint-disable-next-line eqeqeq
            if (res.data.Status == 1) {
              this.$message({
                message: res.data.Data.Name + '打卡成功，刷卡時間為：' + res.data.Data.ClockTime,
                type: 'success'
              })
              this.closePhoneDialog('submit')
            }
            this.clockOutFullscreenLoading = false
          }).catch(err => {
            if (err.response.status === 400 || err.response.status === 404) {
              this.$alert(err.response.data.ErrorMessage.Description, '錯誤', {
                confirmButtonText: '確定',
                closeOnClickModal: false,
                type: 'error',
                callback: action => {
                  this.phoneDialogVisible = true
                }
              })
            }
            this.clockOutFullscreenLoading = false
            console.log('錯誤訊息：', err.response)
          })
        }
      })
    },
    // 關閉輸入手機彈窗
    closePhoneDialog (action) {
      this.phoneDialogVisible = false
      this.$refs.phoneDialogForm.resetFields()
      this.formData.phone = ''
      // eslint-disable-next-line eqeqeq
      if (action == 'submit') { this.$router.push({ name: 'AttendanceManagement' }) } else { this.$emit('backStep1') }
    }
  }
}
</script>
<style lang="sass" scoped>
#ClockOut_main
  ::v-deep .el-dialog.clockOutDialog
    +basicDialog
    .showWebCam
      width: 354px
      height: 217px
      margin: 0 auto 35px
      background-repeat: no-repeat
      background-size: contain
      &.non-webcam
        background-image: url('../../../assets/img/Webcam/non-webcam.jpg')
    .cancelBtn
      margin-top: 30px
  ::v-deep .el-table,.clockOutTable
    +basicTable
  ::v-deep .phoneDialog
    .el-form-item
      margin-bottom: 0
      .el-form-item__label
        padding-bottom: 20px
        color: $subFontColor
</style>
